// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"tUT66":[function(require,module,exports) {
require("a7d8c06d8a64ec63").register(require("8e27477b1024fc3f").getBundleURL('109if'), JSON.parse("[\"109if\",\"iframe.4382e24e.js\",\"7wFrp\",\"Intro.056259f7.js\",\"gADIf\",\"wallpaper_collaborative_S2_desktop.1ae295a9.webp\",\"24PFT\",\"Intro.5fb30e9d.js\",\"4W7WQ\",\"Intro.d15b0ad3.js\",\"hZHTg\",\"Intro.c4f1c92e.css\",\"bKQ59\",\"Intro.741eec9e.js\",\"3Dz3P\",\"Intro.dc5306bb.js\",\"lEbe1\",\"Intro.fa0f8b7d.css\",\"i8y5C\",\"Intro.1c977372.js\",\"78TEq\",\"Intro.87a4aaa2.js\",\"8Uttf\",\"Intro.de1c861c.css\",\"f3YxK\",\"Intro.4b9719e6.js\",\"3zgdJ\",\"Intro.b898665a.js\",\"kEiG5\",\"Intro.e8b58638.js\",\"efvFH\",\"Intro.6c8ae1d3.js\",\"j45GS\",\"Intro.ed8d3b81.css\",\"blxUO\",\"Style Macro.60605aa0.js\",\"5gemJ\",\"Style Macro.722ceb65.css\",\"03cNv\",\"Workflow Icons.deb62840.js\",\"9ivZZ\",\"Workflow Icons.4bcd5ffc.css\",\"gBNue\",\"ActionButton.stories.92bc21a2.js\",\"04pJV\",\"ActionButton.stories.2dbd707f.css\",\"lDZIv\",\"ActionMenu.stories.3d1ae224.js\",\"lINOW\",\"ActionMenu.stories.35fb1962.css\",\"24wID\",\"AlertDialog.stories.4a8eea12.js\",\"g30UF\",\"AlertDialog.stories.a46ea0ca.css\",\"firSE\",\"Avatar.stories.cc4baa19.js\",\"gR1JU\",\"Avatar.stories.52d775ef.css\",\"7goh4\",\"Badge.stories.ca728906.js\",\"jfz4S\",\"Badge.stories.163a674b.css\",\"9o75J\",\"Breadcrumbs.stories.73ac9867.js\",\"jfD5Y\",\"Breadcrumbs.stories.11bfbe55.css\",\"7gQ9x\",\"Button.stories.a0c367b5.js\",\"kXtdn\",\"Button.stories.633caa3e.css\",\"a7Fw6\",\"ButtonGroup.stories.c4e685aa.js\",\"9m9YX\",\"ButtonGroup.stories.fbf82e6c.css\",\"aYH3d\",\"Calendar.stories.87907e81.js\",\"3mHvV\",\"Checkbox.stories.c9f3de19.js\",\"5ydti\",\"Checkbox.stories.0a909699.css\",\"lIbVH\",\"CheckboxGroup.stories.d344bf2b.js\",\"8bLdw\",\"CheckboxGroup.stories.7a2fab69.css\",\"1fOZ2\",\"ColorArea.stories.a442684a.js\",\"bD7cM\",\"ColorArea.stories.25e4499b.css\",\"csBls\",\"ColorField.stories.b3e9cddb.js\",\"ejutY\",\"ColorField.stories.97f0eebf.css\",\"b6K67\",\"ColorSlider.stories.c5931b6a.js\",\"8h8CZ\",\"ColorSlider.stories.2d0d7169.css\",\"ceOy9\",\"ColorSwatch.stories.9b553644.js\",\"jBYAw\",\"ColorSwatch.stories.eaf2a1e5.css\",\"4hKiu\",\"ColorSwatchPicker.stories.ccb4e8dd.js\",\"gxdNi\",\"ColorSwatchPicker.stories.0c4a5db0.css\",\"dWAP7\",\"ColorWheel.stories.4b76790c.js\",\"6qDkr\",\"ColorWheel.stories.9230a94e.css\",\"labZI\",\"ComboBox.stories.783ce508.js\",\"cAUj4\",\"ComboBox.stories.12493739.css\",\"21ZS1\",\"ContextualHelp.stories.e83ebf9a.js\",\"kyp9g\",\"ContextualHelp.stories.a6f9cd82.css\",\"g9QOQ\",\"DateField.stories.ea0fe832.js\",\"1VDOk\",\"DatePicker.stories.f7f7a2ab.js\",\"ifPuk\",\"DateRangePicker.stories.9bc2454d.js\",\"4dngR\",\"Dialog.stories.647db9c9.js\",\"8ndOo\",\"Dialog.stories.097dbe7f.css\",\"7lHM4\",\"Divider.stories.32ad94c3.js\",\"48gkP\",\"Divider.stories.663980f0.css\",\"kZIfP\",\"DropZone.stories.fd1cbc76.js\",\"bUIRn\",\"DropZone.stories.551c2e92.css\",\"cukXS\",\"Form.stories.d24f26a7.js\",\"4Pqu7\",\"Form.stories.658fbcea.css\",\"ecjfP\",\"GridList.stories.76f85ec4.js\",\"ktNIR\",\"GridList.stories.81a8bfa3.css\",\"fio36\",\"Icon.stories.7e4564f0.js\",\"f656v\",\"IllustratedMessage.stories.c228d9f8.js\",\"5DbEg\",\"IllustratedMessage.stories.f34211b9.css\",\"2lCLs\",\"InlineAlert.stories.1a40fa0e.js\",\"Tfios\",\"InlineAlert.stories.a31617f0.css\",\"las2I\",\"Link.stories.5ca00ccb.js\",\"10nEi\",\"Link.stories.3720f3ce.css\",\"d3oh9\",\"LinkButton.stories.425eb3a4.js\",\"8xukM\",\"LinkButton.stories.3e6d79be.css\",\"bahOs\",\"ListBox.stories.2e145b50.js\",\"9SOhh\",\"Menu.stories.1d04f5ac.js\",\"5oqVj\",\"normal.ded32008.png\",\"9iy9B\",\"multiply.9c18c7f4.png\",\"fNBtb\",\"screen.88c89678.png\",\"bSqPJ\",\"Menu.stories.28ca0284.css\",\"jigO3\",\"Meter.stories.73df555f.js\",\"ffsg6\",\"Meter.stories.50249706.css\",\"4voQX\",\"NumberField.stories.52da7def.js\",\"bsr8A\",\"NumberField.stories.1c22856f.css\",\"8PFpd\",\"Picker.stories.b2ff8e95.js\",\"6rfi2\",\"Picker.stories.e00b9862.css\",\"7tIVT\",\"ProgressBar.stories.685e21f0.js\",\"gSRme\",\"ProgressBar.stories.28cf81b0.css\",\"h0foo\",\"ProgressCircle.stories.8798ef51.js\",\"4rpvB\",\"ProgressCircle.stories.ac25133d.css\",\"cbsFe\",\"RadioGroup.stories.701308bc.js\",\"j1Jzd\",\"RadioGroup.stories.760dea5b.css\",\"aCQrF\",\"RangeCalendar.stories.8cc5c756.js\",\"h9JJA\",\"RangeSlider.stories.c1e72997.js\",\"iqeF5\",\"RangeSlider.stories.17392a78.css\",\"hGkdf\",\"SearchField.stories.bec9eadb.js\",\"gTRhP\",\"SearchField.stories.9d7fdae1.css\",\"4HP7w\",\"Slider.stories.890703ec.js\",\"f4LQa\",\"Slider.stories.1879448d.css\",\"9sLLt\",\"StatusLight.stories.8ee673f9.js\",\"hKmbO\",\"StatusLight.stories.d2147848.css\",\"bWmUf\",\"Switch.stories.d6da3706.js\",\"l4vvm\",\"Switch.stories.508a840b.css\",\"9xh5D\",\"Table.stories.f3b2441a.js\",\"7ssMw\",\"Table.stories.dbeef563.css\",\"03a3B\",\"Tabs.stories.65b26aaf.js\",\"9lhWw\",\"TagGroup.stories.5fe42dfd.js\",\"fB4uM\",\"TagGroup.stories.aadb6b7c.css\",\"dsTHl\",\"TextField.stories.9d4d62bb.js\",\"1pqPQ\",\"TextField.stories.87e6e13c.css\",\"gsAX3\",\"TimeField.stories.a73a1446.js\",\"lpK4d\",\"ToggleButton.stories.08bbaa7f.js\",\"4CRFr\",\"ToggleButton.stories.bfb22c76.css\",\"8bP2Q\",\"Toolbar.stories.a71bbefc.js\",\"cPafQ\",\"Tooltip.stories.d916f646.js\",\"179Ws\",\"Tooltip.stories.19e6c4e3.css\",\"egbhx\",\"entry-preview.3ec6419f.js\",\"hcuvC\",\"entry-preview-docs.deb4906e.js\",\"c0fxE\",\"entry-preview-docs.6a355f74.js\",\"j6xp0\",\"preview.7665bc47.js\",\"lGXXw\",\"preview.dcfbaea5.js\",\"beHSG\",\"react.9779f578.js\",\"iVi8B\",\"preview.9c0067a9.js\",\"XoJWs\",\"Color-6VNJS4EI.3a9d8404.js\",\"kNmit\",\"syntaxhighlighter-B5GMVT5T.9733b8e5.js\",\"7FGSu\",\"formatter-SWP5E3XI.25bbb327.js\",\"5gSLI\",\"WithTooltip-V3YHNWJZ.601a454d.js\",\"6bkLK\",\"preview.649b42cf.js\",\"1kMc2\",\"preview.6801119b.js\",\"6EFKw\",\"preview.6e68ea4a.js\",\"atKAY\",\"preview.efb0efbb.js\",\"lTL2Q\",\"preview.a4b18ddc.js\",\"7l5FC\",\"preview.d7310ff9.js\",\"luNwF\",\"preview.dad507fa.js\",\"35bjJ\",\"logo.2bd7c023.svg\",\"chPnz\",\"logo-dark.aa58a0ab.svg\",\"jPyn3\",\"preview.2f942dcf.css\"]"));

},{"a7d8c06d8a64ec63":"kK08P","8e27477b1024fc3f":"kMf2L"}],"kK08P":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"kMf2L":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["tUT66"], null, "parcelRequire94c2")

//# sourceMappingURL=iframe.runtime.a43dbd40.js.map
